import { Injectable } from '@angular/core';

import { BaseService } from '../abstracts/base.service';
import { ResultModel } from '../models/result.model';
import { map } from 'rxjs/operators';
import { PasswordModel } from '../models/password.model';

@Injectable({
  providedIn: 'root'
})
export class PasswordService extends BaseService {

  changePassword(password: PasswordModel){
    return this.httpClient.put<ResultModel>(this.getApiUrl('auth/change-password'), password);
  }

}
